import { SavedAttachmentInfo } from "@/entities/attachments/types";
import { APIObject } from "@/services/api/types";
import { EntityType } from "@/services/hooks/entities/entityTypes";
import { ISOStringFormat } from "date-fns";

export enum ReminderTimePeriod {
  DAYS = 1,
  WEEKS = 2,
  CUSTOM = 3
}

export enum TaskState {
  OPEN = "open",
  COMPLETED = "completed"
}

export enum TaskTabs {
  ALL_TASKS = "allTasks",
  ASSIGNED_TO_ME = "assignedToMe",
  ASSIGNED_BY_ME = "assignedByMe"
}

interface TaskEntity {
  entityId: string;
  entityName: string;
}

interface TaskLink {
  entityId: string;
  entityName: string;
  entityType: EntityType | undefined;
}

interface Reminder {
  id: string;
  value: number | null;
  timePeriod: ReminderTimePeriod | null;
  customDate: ISOStringFormat | null;
}

interface DreamerSource {
  activityId: string;
  activityType: string;
  activityTitle: string;
  activityDate: string | null;
  sourceQuote: string | null;
}

interface DreamerMetadata {
  sources: DreamerSource[];
}

interface TaskData extends APIObject {
  entityIds: string[];
  title: string;
  description: string | null;
  isCompleted: boolean;
  assigneeId: string;
  dueDate: ISOStringFormat;
  reminders: { items: Reminder[] } | null;
  shouldOnlyNotifyAssignee: boolean;
  isHighPriority: boolean;
  attachments: { items: SavedAttachmentInfo[] } | null;
  completedAt: ISOStringFormat | null;
  completedBy: string | null;
  isCreatedByDreamer: boolean;
  dreamerMetadata?: DreamerMetadata | null;
  createdBy: string | null;
  createdAt: ISOStringFormat | null;
  entities: TaskEntity[] | null;
  entityNames?: TaskEntity[] | null;
}

interface TaskFormData {
  title: string;
  description: string | null;
  isCompleted: boolean;
  assigneeId: string;
  dueDate: ISOStringFormat;
  reminders: Reminder[] | null;
  shouldOnlyNotifyAssignee: boolean;
  isHighPriority: string;
  attachments: SavedAttachmentInfo[] | null;
  completedAt: ISOStringFormat | null;
  completedBy: string | null;
  isCreatedByDreamer: boolean;
  createdBy: string | null;
  createdAt: ISOStringFormat | null;
  dealId: string;
  leadId: string;
  companyId: string;
  contactId: string;
  contractId: string;
  linkTo?: string;
}

interface TaskModalState {
  isOpen: boolean;
  isEditMode: boolean;
  editTaskId: string | null;
  editTaskData?: TaskData;
}

interface DeleteTaskModalState {
  isOpen: boolean;
  task: {
    id: string | null;
    name: string | null;
  };
}

type EntityMapping = Partial<
  Record<
    EntityType,
    {
      prefix: string;
      setter?: React.Dispatch<React.SetStateAction<string | undefined>>;
      field: keyof TaskFormData;
      icon?: JSX.Element;
    }
  >
>;

export type {
  TaskData,
  TaskEntity,
  TaskLink,
  Reminder,
  TaskModalState,
  DeleteTaskModalState,
  TaskFormData,
  EntityMapping,
  DreamerSource,
  DreamerMetadata
};
